<template>
  <div class="course-manager-container">
    <!-- 页面标题和操作区域 -->
    <div class="header">
      <div class="title-section">
        <div class="title-row">
          <h2 class="page-title">课程管理中心</h2>
          <button class="add-btn" @click="showAddCourseDialog">
            <img src="@/assets/add.png" alt="新增课程" class="icon" />
            <span>新增课程</span>
          </button>
        </div>
        <span class="all-courses">全部课程</span>
        <div class="divider"></div>
      </div>
    </div>

    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="search-container">
        <input
          type="text"
          placeholder="搜索课程名称..."
          v-model="searchKeyword"
          class="search-input"
          @keyup.enter="handleSearch"
        />
        <button class="search-btn" @click="handleSearch">
          <img src="@/assets/search-icon.png" alt="搜索" class="icon" />
          <span>搜索</span>
        </button>
      </div>
    </div>

    <!-- 课程列表 -->
    <div class="course-list">
      <CourseCard
        v-for="course in filteredCourses"
        :key="course.id"
        :id="course.id"
        :videoId="course.id"
        :course="course"
      />
    </div>

    <!-- 新增课程对话框 -->
    <CourseDialog
      v-if="showDialog"
      :visible="showDialog"
      :course="currentCourse"
      @close="handleDialogClose"
      @save="handleSaveCourse"
    />
  </div>
</template>

<script>
import CourseCard from "./CourseCard.vue";
import CourseDialog from "./CourseDialog.vue";
// axios已在main.js中全局配置，使用this.$http代替直接导入的axios

export default {
  name: "CourseManagerPage",
  components: {
    CourseCard,
    CourseDialog,
  },
  data() {
    return {
      searchKeyword: "",
      showDialog: false,
      currentCourse: null,
      courses: [],
    };
  },
  computed: {
    filteredCourses() {
      return this.courses.filter(
        (course) =>
          course.name
            .toLowerCase()
            .includes(this.searchKeyword.toLowerCase()) ||
          course.category
            .toLowerCase()
            .includes(this.searchKeyword.toLowerCase())
      );
    },
  },
  mounted() {
    this.fetchCourses();
  },
  methods: {
    async fetchCourses() {
      this.loading = true;
      this.error = "";

      try {
        // 使用this.$http代替直接导入的axios，确保token自动添加
        const response = await this.$http.get("/training");

        if (response.data && Array.isArray(response.data)) {
          this.courses = response.data.map((item) => ({
            id: item.id,
            name: item.trainingCourse,
            category: item.courseType,
            description: item.courseDescription,
            assigned: item.assign,
            score: item.credits,
            duration: item.courseTotalTime,
            credits: item.credits,
            videoState: item.videoState,
            image:
              item.coverUrl ||
              "https://picsum.photos/300/200?random=" + item.id,
            videoUrl: item.courseUrl,
          }));
          this.$message.success("课程数据加载成功");
        } else {
          this.error = "获取课程数据格式错误";
          this.$message.error(this.error);
        }
      } catch (err) {
        console.error("获取课程数据失败:", err);
        // 401错误已在main.js中统一处理，这里不再重复处理
        this.error = "获取课程数据失败，请检查网络连接";
        this.$message.error(this.error);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      console.log("搜索关键词:", this.searchKeyword);
    },
    showAddCourseDialog() {
      this.currentCourse = {
        id: null,
        name: "",
        category: "",
        description: "",
        assigned: "",
        score: 0,
        duration: 0,
        credits: 0,
        image: "",
        videoUrl: "",
        videoState: "未开始",
      };
      this.showDialog = true;
    },
    handleDialogClose() {
      this.showDialog = false;
      this.currentCourse = null;
    },
    handleSaveCourse(course) {
      if (course.id) {
        // 更新现有课程
        const index = this.courses.findIndex((c) => c.id === course.id);
        if (index !== -1) {
          this.courses.splice(index, 1, course);
        }
      } else {
        // 新增课程
        course.id = this.generateCourseId();
        this.courses.unshift(course);
      }
      this.showDialog = false;
    },
    generateCourseId() {
      return this.courses.length > 0
        ? Math.max(...this.courses.map((c) => c.id)) + 1
        : 1;
    },
  },
};
</script>

<style scoped>
.course-manager-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.header {
  margin-bottom: 20px;
}

.title-section {
  width: 100%;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.all-courses {
  font-size: 16px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 10px 0;
}

.add-btn {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.add-btn:hover {
  background-color: #40a9ff;
}

.add-btn .icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.search-section {
  margin-bottom: 20px;
}

.search-container {
  display: flex;
  max-width: 500px;
}

.search-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px 0 0 4px;
  outline: none;
}

.search-input:focus {
  border-color: #40a9ff;
}

.search-btn {
  padding: 8px 16px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}

.search-btn:hover {
  background-color: #40a9ff;
}

.search-btn .icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.course-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}
</style>
